<template>
  <div>

    <svg id="katman_1" data-name="katman 1" xmlns="http://www.w3.org/2000/svg" width="72mm" height="25.3mm"
         viewBox="0 0 204.09 71.73">






        <g>


	<path d="M66.8,2.6h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1


		V6.1c0,0,0,0,0,0s0,0,0,0l-1,1.7c0,0.1-0.1,0.1-0.2,0.1h-0.9c-0.1,0-0.1,0-0.2-0.1l-1-1.7c0,0,0,0,0,0s0,0,0,0v4.8c0,0,0,0.1,0,0.1


		c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0.1,0,0.1,0,0.2,0.1l1.7,2.6


		c0,0,0,0,0.1,0l1.6-2.6C66.7,2.7,66.7,2.6,66.8,2.6z"/>


          <path d="M75.8,4.3c0,0-0.1,0-0.1,0h-3.8c0,0-0.1,0-0.1,0.1v1.5c0,0,0,0.1,0.1,0.1h2.4c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-2.4c0,0-0.1,0-0.1,0.1v1.6c0,0,0,0.1,0.1,0.1h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0H70c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1s0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1v1.4C75.8,4.2,75.8,4.3,75.8,4.3z"/>


          <path d="M78.1,10.8c-0.5-0.2-0.9-0.5-1.1-0.9c-0.3-0.4-0.4-0.9-0.4-1.4V8.3c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0


		s0,0.1,0,0.1v0.1c0,0.3,0.1,0.5,0.4,0.7c0.3,0.2,0.6,0.3,1.1,0.3c0.4,0,0.6-0.1,0.8-0.2S81,8.9,81,8.7c0-0.2-0.1-0.3-0.1-0.4


		c-0.1-0.1-0.2-0.2-0.4-0.3C80.3,8,80,7.9,79.7,7.8c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c-0.5-0.2-1-0.4-1.4-0.5


		c-0.4-0.2-0.7-0.5-1-0.8S76.6,5.5,76.6,5c0-0.5,0.1-0.9,0.4-1.3c0.3-0.4,0.6-0.7,1.1-0.9c0.5-0.2,1-0.3,1.6-0.3


		c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.5,1.2,0.9c0.3,0.4,0.4,0.9,0.4,1.4v0.2c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7


		c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V5.3c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0.1-0.7,0.2


		c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.1,0.4c0.6,0.2,1,0.4,1.3,0.5


		s0.6,0.4,0.9,0.7C82.8,7.7,83,8.1,83,8.6c0,0.5-0.1,1-0.4,1.3c-0.3,0.4-0.6,0.7-1.1,0.9s-1,0.3-1.7,0.3


		C79.1,11.1,78.6,11,78.1,10.8z"/>


          <path d="M84,11c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v3.1c0,0,0,0,0,0c0,0,0,0,0,0


		l2.4-3.2c0-0.1,0.1-0.1,0.2-0.1h1.9c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1L88,6.3c0,0,0,0.1,0,0.1l2.7,4.5c0,0,0,0.1,0,0.1


		c0,0.1,0,0.1-0.1,0.1h-1.9c-0.1,0-0.1,0-0.2-0.1l-1.9-3.2c0,0-0.1,0-0.1,0L86,8.6c0,0,0,0.1,0,0.1v2.2c0,0,0,0.1,0,0.1


		c0,0-0.1,0-0.1,0h-1.7C84.1,11,84,11,84,11z"/>


          <path d="M97.4,4.3c0,0-0.1,0-0.1,0h-3.8c0,0-0.1,0-0.1,0.1v1.5c0,0,0,0.1,0.1,0.1H96c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-2.4c0,0-0.1,0-0.1,0.1v1.6c0,0,0,0.1,0.1,0.1h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1s0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1v1.4C97.5,4.2,97.5,4.3,97.4,4.3z"/>


          <path d="M103.3,2.7c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.6


		c-0.1,0-0.1,0-0.2-0.1l-2.8-4.6c0,0,0,0,0,0s0,0,0,0.1l0,4.5c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.6c0.1,0,0.1,0,0.2,0.1l2.7,4.6c0,0,0,0,0,0c0,0,0,0,0-0.1l0-4.5


		C103.2,2.7,103.2,2.7,103.3,2.7z"/>


          <path d="M107.7,10.8c-0.5-0.2-0.9-0.5-1.1-0.9c-0.3-0.4-0.4-0.9-0.4-1.4V8.3c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1v0.1c0,0.3,0.1,0.5,0.4,0.7c0.3,0.2,0.6,0.3,1.1,0.3c0.4,0,0.6-0.1,0.8-0.2s0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4


		c-0.1-0.1-0.2-0.2-0.4-0.3s-0.4-0.2-0.8-0.3c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c-0.5-0.2-1-0.4-1.4-0.5c-0.4-0.2-0.7-0.5-1-0.8


		c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.5,0.1-0.9,0.4-1.3s0.6-0.7,1.1-0.9c0.5-0.2,1-0.3,1.6-0.3c0.6,0,1.2,0.1,1.7,0.3


		c0.5,0.2,0.9,0.5,1.2,0.9c0.3,0.4,0.4,0.9,0.4,1.4v0.2c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V5.3


		c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0.1-0.7,0.2s-0.3,0.3-0.3,0.5c0,0.2,0.1,0.3,0.2,0.4


		c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.1,0.4c0.6,0.2,1,0.4,1.3,0.5c0.3,0.1,0.6,0.4,0.9,0.7c0.3,0.3,0.4,0.8,0.4,1.3


		c0,0.5-0.1,1-0.4,1.3c-0.3,0.4-0.6,0.7-1.1,0.9c-0.5,0.2-1,0.3-1.7,0.3C108.8,11.1,108.2,11,107.7,10.8z"/>


          <path d="M113.8,1.8c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.8-0.3c0.3,0,0.6,0.1,0.7,0.3


		c0.2,0.2,0.3,0.4,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.3-0.7,0.3C114.3,2.1,114,2,113.8,1.8z M113.6,11c0,0,0-0.1,0-0.1


		V2.8c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7


		C113.7,11,113.6,11,113.6,11z"/>


          <path d="M116.5,11c0,0,0-0.1,0-0.1V9.3c0-0.1,0-0.1,0.1-0.2l3.7-4.7c0,0,0,0,0,0s0,0,0,0h-3.6c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V2.8


		c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.6c0,0.1,0,0.1-0.1,0.2l-3.7,4.7c0,0,0,0,0,0s0,0,0,0h3.6


		c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7C116.6,11,116.6,11,116.5,11z"/>


          <path d="M131.1,6.7c0.7,0.4,1.1,1,1.1,1.9c0,0.8-0.3,1.4-0.8,1.8s-1.3,0.6-2.2,0.6H126c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V2.8


		c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h3.1c1,0,1.7,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8C132.1,5.8,131.7,6.3,131.1,6.7


		C131.1,6.7,131.1,6.7,131.1,6.7z M127.9,4.4v1.5c0,0,0,0.1,0.1,0.1h1.2c0.3,0,0.6-0.1,0.8-0.2c0.2-0.1,0.3-0.3,0.3-0.6


		c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.4-0.2-0.8-0.2L127.9,4.4C127.9,4.3,127.9,4.4,127.9,4.4z M129.9,9.1c0.2-0.1,0.3-0.4,0.3-0.6


		c0-0.3-0.1-0.5-0.3-0.6s-0.4-0.2-0.8-0.2h-1.3c0,0-0.1,0-0.1,0.1v1.6c0,0,0,0.1,0.1,0.1h1.3C129.5,9.3,129.8,9.2,129.9,9.1z"/>


          <path d="M133.5,1.8c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.8-0.3c0.3,0,0.6,0.1,0.7,0.3


		c0.2,0.2,0.3,0.4,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.3-0.7,0.3C134,2.1,133.7,2,133.5,1.8z M133.3,11c0,0,0-0.1,0-0.1


		V2.8c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7


		C133.4,11,133.3,11,133.3,11z"/>


          <path d="M141.3,2.7c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.6


		c-0.1,0-0.1,0-0.2-0.1l-2.8-4.6c0,0,0,0,0,0c0,0,0,0,0,0.1l0,4.5c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.6c0.1,0,0.1,0,0.2,0.1l2.7,4.6c0,0,0,0,0,0c0,0,0,0,0-0.1l0-4.5


		C141.2,2.7,141.2,2.7,141.3,2.7z"/>


          <path d="M149.7,10.9l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C149.8,11,149.7,11,149.7,10.9z M147.1,8.3h1.8c0,0,0.1,0,0-0.1L148,5.1c0,0,0,0,0,0c0,0,0,0,0,0L147.1,8.3


		C147,8.2,147,8.3,147.1,8.3z"/>


          <path d="M152.8,11c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v6.5c0,0,0,0.1,0.1,0.1h3.8


		c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7C152.8,11,152.8,11,152.8,11z"/>


          <path d="M165,10.9l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C165.1,11,165,11,165,10.9z M162.4,8.3h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L162.4,8.3


		C162.3,8.2,162.3,8.3,162.4,8.3z"/>


          <path d="M172.4,10.9l-1.4-3.2c0,0,0,0-0.1,0h-0.8c0,0-0.1,0-0.1,0.1v3.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1s0.1,0,0.1,0h3.6c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.9,0.3,1.4


		c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.7-1.1,0.9c0,0-0.1,0,0,0.1l1.6,3.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C172.4,11,172.4,11,172.4,10.9z M170,4.4v1.7c0,0,0,0.1,0.1,0.1h1.3c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.7


		c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3L170,4.4C170,4.3,170,4.4,170,4.4z"/>


          <path d="M175.4,11c0,0,0-0.1,0-0.1V2.8c0,0,0-0.1,0-0.1s0.1,0,0.1,0h3.1c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.5,1.1,0.9


		c0.3,0.4,0.4,0.9,0.4,1.4v3.1c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.7-1.1,0.9c-0.5,0.2-1,0.3-1.7,0.3h-3.1


		C175.5,11,175.5,11,175.4,11z M177.4,9.3h1.2c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.9V5.6c0-0.4-0.1-0.7-0.3-0.9


		s-0.5-0.3-0.8-0.3h-1.2c0,0-0.1,0-0.1,0.1L177.4,9.3C177.4,9.3,177.4,9.3,177.4,9.3z"/>


          <path d="M187.6,10.9l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C187.7,11,187.6,11,187.6,10.9z M185,8.3h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L185,8.3


		C184.9,8.2,184.9,8.3,185,8.3z"/>


          <path d="M67.2,16.7c0,0-0.1,0-0.1,0h-3.8c0,0-0.1,0-0.1,0.1v1.5c0,0,0,0.1,0.1,0.1h2.4c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-2.4c0,0-0.1,0-0.1,0.1v1.6c0,0,0,0.1,0.1,0.1h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1v1.4C67.2,16.6,67.2,16.7,67.2,16.7z"/>


          <path d="M68.2,23.4c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0H70c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v6.5c0,0,0,0.1,0.1,0.1


		h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7C68.3,23.4,68.3,23.4,68.2,23.4z"/>


          <path d="M81,16.7c0,0-0.1,0-0.1,0h-3.8c0,0-0.1,0-0.1,0.1v1.5c0,0,0,0.1,0.1,0.1h2.4c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-2.4c0,0-0.1,0-0.1,0.1v1.6c0,0,0,0.1,0.1,0.1h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1v1.4C81,16.6,81,16.7,81,16.7z"/>


          <path d="M82,23.4c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v3.1c0,0,0,0,0,0


		c0,0,0,0,0,0l2.4-3.2c0-0.1,0.1-0.1,0.2-0.1h1.9c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1l-2.6,3.5c0,0,0,0.1,0,0.1l2.7,4.5


		c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.9c-0.1,0-0.1,0-0.2-0.1l-1.9-3.2c0,0-0.1,0-0.1,0L84,21c0,0,0,0.1,0,0.1v2.2


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7C82.1,23.4,82.1,23.4,82,23.4z"/>


          <path d="M95.7,15.1c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-2.1c0,0-0.1,0-0.1,0.1v6.5c0,0,0,0.1,0,0.1


		c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-6.5c0,0,0-0.1-0.1-0.1h-2c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-1.4


		c0,0,0-0.1,0-0.1s0.1,0,0.1,0h6.2C95.7,15,95.7,15.1,95.7,15.1z"/>


          <path d="M101,23.3l-1.4-3.2c0,0,0,0-0.1,0h-0.8c0,0-0.1,0-0.1,0.1v3.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h3.6c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.9,0.3,1.4


		c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.7-1.1,0.9c0,0-0.1,0,0,0.1l1.6,3.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C101.1,23.4,101,23.4,101,23.3z M98.6,16.8v1.7c0,0,0,0.1,0.1,0.1h1.3c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.7


		c0-0.3-0.1-0.5-0.3-0.7s-0.4-0.3-0.7-0.3L98.6,16.8C98.7,16.7,98.6,16.8,98.6,16.8z"/>


          <path d="M104.3,14.2c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8s0.4-0.3,0.8-0.3s0.6,0.1,0.7,0.3s0.3,0.4,0.3,0.8


		c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.3-0.7,0.3C104.7,14.5,104.5,14.4,104.3,14.2z M104.1,23.4c0,0,0-0.1,0-0.1v-8.1


		c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7


		C104.1,23.4,104.1,23.4,104.1,23.4z"/>


          <path d="M107.2,23.4c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v3.1c0,0,0,0,0,0


		c0,0,0,0,0,0l2.4-3.2c0-0.1,0.1-0.1,0.2-0.1h1.9c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1l-2.6,3.5c0,0,0,0.1,0,0.1l2.7,4.5


		c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1H112c-0.1,0-0.1,0-0.2-0.1l-1.9-3.2c0,0-0.1,0-0.1,0l-0.6,0.9c0,0,0,0.1,0,0.1v2.2


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7C107.3,23.4,107.3,23.4,107.2,23.4z"/>


          <path d="M118.5,23.2c-0.5-0.2-0.9-0.5-1.1-0.9c-0.3-0.4-0.4-0.9-0.4-1.4v-0.2c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1v0.1c0,0.3,0.1,0.5,0.4,0.7c0.3,0.2,0.6,0.3,1.1,0.3c0.4,0,0.6-0.1,0.8-0.2s0.3-0.3,0.3-0.5c0-0.2-0.1-0.3-0.2-0.4


		s-0.2-0.2-0.4-0.3c-0.2-0.1-0.4-0.2-0.8-0.3c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c-0.5-0.2-1-0.4-1.4-0.5c-0.4-0.2-0.7-0.5-1-0.8


		c-0.3-0.3-0.4-0.8-0.4-1.3c0-0.5,0.1-0.9,0.4-1.3c0.3-0.4,0.6-0.7,1.1-0.9c0.5-0.2,1-0.3,1.6-0.3c0.6,0,1.2,0.1,1.7,0.3


		c0.5,0.2,0.9,0.5,1.2,0.9c0.3,0.4,0.4,0.9,0.4,1.4v0.2c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.1


		c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0.1-0.7,0.2c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.2,0.1,0.3,0.2,0.4


		c0.1,0.1,0.3,0.2,0.5,0.3s0.6,0.2,1.1,0.4c0.6,0.2,1,0.4,1.3,0.5c0.3,0.1,0.6,0.4,0.9,0.7c0.3,0.3,0.4,0.8,0.4,1.3


		c0,0.5-0.1,1-0.4,1.3s-0.6,0.7-1.1,0.9c-0.5,0.2-1,0.3-1.7,0.3C119.5,23.5,119,23.4,118.5,23.2z"/>


          <path d="M129.7,23.3l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C129.7,23.4,129.7,23.4,129.7,23.3z M127,20.7h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L127,20.7


		C127,20.6,127,20.7,127,20.7z"/>


          <path d="M133.8,23.4c0,0,0-0.1,0-0.1v-2.8c0,0,0-0.1,0-0.1l-2.5-5.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.1h1.8c0.1,0,0.1,0,0.2,0.1


		l1.3,3c0,0,0,0,0.1,0l1.3-3c0-0.1,0.1-0.1,0.2-0.1h1.9c0.1,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1l-2.5,5.1c0,0,0,0,0,0.1v2.8


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7C133.9,23.4,133.8,23.4,133.8,23.4z"/>


          <path d="M142.8,23.3l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1H143


		C142.9,23.4,142.8,23.4,142.8,23.3z M140.2,20.7h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L140.2,20.7


		C140.1,20.6,140.1,20.7,140.2,20.7z"/>


          <path d="M151.8,17.9c0,0-0.1,0-0.1,0L150,18c-0.1,0-0.1,0-0.1-0.1c0-0.4-0.1-0.7-0.3-0.9c-0.2-0.2-0.5-0.3-0.9-0.3


		c-0.4,0-0.7,0.1-0.9,0.3c-0.2,0.2-0.3,0.5-0.3,0.9v2.7c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,0.9,0.3c0.4,0,0.7-0.1,0.9-0.3


		s0.3-0.5,0.3-0.9c0-0.1,0-0.1,0.1-0.1l1.7,0.1c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0.8-0.2,1.4-0.7,1.9c-0.5,0.5-1.1,0.8-1.9,0.9


		c-0.1,0-0.1,0,0,0.1c0.3,0.3,0.5,0.7,0.5,1c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.2,0.5-0.4,0.6c-0.2,0.1-0.5,0.2-0.7,0.2


		c-0.3,0-0.6-0.1-0.8-0.2c-0.1,0-0.1-0.1-0.1-0.2l0.1-0.7c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2-0.1


		s0.1-0.1,0.1-0.2c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.3-0.3-0.5-0.5c0,0,0,0,0,0s0,0,0,0c-0.7-0.2-1.2-0.5-1.7-1


		c-0.4-0.5-0.6-1.1-0.6-1.9v-2.6c0-0.6,0.1-1.1,0.4-1.6c0.3-0.5,0.6-0.8,1.1-1s1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4


		c0.5,0.2,0.9,0.6,1.1,1c0.3,0.4,0.4,0.9,0.4,1.5L151.8,17.9C151.8,17.9,151.8,17.9,151.8,17.9z"/>


          <path d="M152.9,23.4c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v6.5c0,0,0,0.1,0.1,0.1h3.8


		c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0H153C152.9,23.4,152.9,23.4,152.9,23.4z"/>


          <path d="M165.1,23.3l-0.3-1.1c0,0,0,0-0.1,0H162c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C165.2,23.4,165.1,23.4,165.1,23.3z M162.5,20.7h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L162.5,20.7


		C162.4,20.6,162.4,20.7,162.5,20.7z"/>


          <path d="M172.5,23.3l-1.4-3.2c0,0,0,0-0.1,0h-0.8c0,0-0.1,0-0.1,0.1v3.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h3.6c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.9,0.3,1.4


		c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.7-1.1,0.9c0,0-0.1,0,0,0.1l1.6,3.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C172.5,23.4,172.5,23.4,172.5,23.3z M170.1,16.8v1.7c0,0,0,0.1,0.1,0.1h1.3c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.7


		c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3L170.1,16.8C170.1,16.7,170.1,16.8,170.1,16.8z"/>


          <path d="M175.5,23.4c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1


		c0,0-0.1,0-0.1,0h-1.7C175.6,23.4,175.6,23.4,175.5,23.4z"/>


          <path d="M183.5,15.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.6


		c-0.1,0-0.1,0-0.2-0.1l-2.8-4.6c0,0,0,0,0,0c0,0,0,0,0,0.1l0,4.5c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.6c0.1,0,0.1,0,0.2,0.1l2.7,4.6c0,0,0,0,0,0c0,0,0,0,0-0.1l0-4.5


		C183.4,15.1,183.5,15.1,183.5,15.1z"/>


          <path d="M186.7,23.4c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1


		c0,0-0.1,0-0.1,0h-1.7C186.7,23.4,186.7,23.4,186.7,23.4z"/>


          <path d="M189.6,23.4c0,0,0-0.1,0-0.1v-1.6c0-0.1,0-0.1,0.1-0.2l3.7-4.7c0,0,0,0,0,0s0,0,0,0h-3.6c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1


		v-1.4c0,0,0-0.1,0-0.1s0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v1.6c0,0.1,0,0.1-0.1,0.2l-3.7,4.7c0,0,0,0,0,0c0,0,0,0,0,0h3.6


		c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7C189.7,23.4,189.6,23.4,189.6,23.4z"/>


          <path d="M196.5,23.4c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1


		c0,0-0.1,0-0.1,0h-1.7C196.6,23.4,196.6,23.4,196.5,23.4z"/>


          <path d="M61.5,26.6c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.8-0.3c0.3,0,0.6,0.1,0.7,0.3


		c0.2,0.2,0.3,0.4,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.3-0.7,0.3C62,26.9,61.7,26.8,61.5,26.6z M61.3,35.8


		c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7


		C61.4,35.8,61.3,35.8,61.3,35.8z"/>


          <path d="M64.5,35.8c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v3.1c0,0,0,0,0,0


		c0,0,0,0,0,0l2.4-3.2c0-0.1,0.1-0.1,0.2-0.1H71c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1l-2.6,3.5c0,0,0,0.1,0,0.1l2.7,4.5


		c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.9c-0.1,0-0.1,0-0.2-0.1l-1.9-3.2c0,0-0.1,0-0.1,0l-0.6,0.9c0,0,0,0.1,0,0.1v2.2


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7C64.6,35.8,64.5,35.8,64.5,35.8z"/>


          <path d="M77.4,35.7l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C77.5,35.8,77.4,35.8,77.4,35.7z M74.8,33.1h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L74.8,33.1


		C74.7,33,74.7,33.1,74.8,33.1z"/>


          <path d="M86,27.4h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0H86c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1


		v-4.8c0,0,0,0,0,0s0,0,0,0l-1,1.7c0,0.1-0.1,0.1-0.2,0.1h-0.9c-0.1,0-0.1,0-0.2-0.1l-1-1.7c0,0,0,0,0,0s0,0,0,0v4.8


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0.1,0,0.1,0,0.2,0.1


		l1.7,2.6c0,0,0,0,0.1,0l1.6-2.6C85.8,27.5,85.9,27.4,86,27.4z"/>


          <path d="M94.9,29.1c0,0-0.1,0-0.1,0H91c0,0-0.1,0-0.1,0.1v1.5c0,0,0,0.1,0.1,0.1h2.4c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0H91c0,0-0.1,0-0.1,0.1v1.6c0,0,0,0.1,0.1,0.1h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1V29C94.9,29,94.9,29.1,94.9,29.1z"/>


          <path d="M99.6,35.6c-0.5-0.2-0.9-0.5-1.1-0.9c-0.3-0.4-0.4-0.9-0.4-1.4v-0.2c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0


		s0,0.1,0,0.1v0.1c0,0.3,0.1,0.5,0.4,0.7c0.3,0.2,0.6,0.3,1.1,0.3c0.4,0,0.6-0.1,0.8-0.2s0.3-0.3,0.3-0.5c0-0.2-0.1-0.3-0.1-0.4


		c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.4-0.2-0.8-0.3c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c-0.5-0.2-1-0.4-1.4-0.5


		c-0.4-0.2-0.7-0.5-1-0.8s-0.4-0.8-0.4-1.3c0-0.5,0.1-0.9,0.4-1.3c0.3-0.4,0.6-0.7,1.1-0.9c0.5-0.2,1-0.3,1.6-0.3


		c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.5,1.2,0.9c0.3,0.4,0.4,0.9,0.4,1.4v0.2c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7


		c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.1c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0.1-0.7,0.2


		c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.1,0.4c0.6,0.2,1,0.4,1.3,0.5


		c0.3,0.1,0.6,0.4,0.9,0.7c0.3,0.3,0.4,0.8,0.4,1.3c0,0.5-0.1,1-0.4,1.3s-0.6,0.7-1.1,0.9c-0.5,0.2-1,0.3-1.7,0.3


		C100.7,35.9,100.1,35.8,99.6,35.6z"/>


          <path d="M110.8,35.7l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1H111


		C110.9,35.8,110.8,35.8,110.8,35.7z M108.2,33.1h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L108.2,33.1


		C108.1,33,108.1,33.1,108.2,33.1z"/>


          <path d="M115,35.8c0,0,0-0.1,0-0.1v-2.8c0,0,0-0.1,0-0.1l-2.5-5.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.1h1.8c0.1,0,0.1,0,0.2,0.1


		l1.3,3c0,0,0,0,0.1,0l1.3-3c0-0.1,0.1-0.1,0.2-0.1h1.9c0.1,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1l-2.5,5.1c0,0,0,0,0,0.1v2.8


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7C115,35.8,115,35.8,115,35.8z"/>


          <path d="M123.9,35.7l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C124,35.8,124,35.8,123.9,35.7z M121.3,33.1h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L121.3,33.1


		C121.2,33,121.3,33.1,121.3,33.1z"/>


          <path d="M132.9,30.3c0,0-0.1,0-0.1,0l-1.7,0.1c-0.1,0-0.1,0-0.1-0.1c0-0.4-0.1-0.7-0.3-0.9c-0.2-0.2-0.5-0.3-0.9-0.3


		s-0.7,0.1-0.9,0.3c-0.2,0.2-0.3,0.5-0.3,0.9V33c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,0.9,0.3s0.7-0.1,0.9-0.3s0.3-0.5,0.3-0.9


		c0-0.1,0-0.1,0.1-0.1l1.7,0.1c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0.8-0.2,1.4-0.7,1.9c-0.5,0.5-1.1,0.8-1.9,0.9c-0.1,0-0.1,0,0,0.1


		c0.3,0.3,0.5,0.7,0.5,1c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.2,0.5-0.4,0.6s-0.5,0.2-0.7,0.2s-0.6-0.1-0.8-0.2c-0.1,0-0.1-0.1-0.1-0.2


		l0.1-0.7c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.3-0.1-0.4


		c-0.1-0.1-0.3-0.3-0.5-0.5c0,0,0,0,0,0c0,0,0,0,0,0c-0.7-0.2-1.2-0.5-1.7-1c-0.4-0.5-0.6-1.1-0.6-1.9v-2.6c0-0.6,0.1-1.1,0.4-1.6


		c0.3-0.5,0.6-0.8,1.1-1c0.5-0.2,1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.2,0.9,0.6,1.1,1c0.3,0.4,0.4,0.9,0.4,1.5L132.9,30.3


		C133,30.3,132.9,30.3,132.9,30.3z"/>


          <path d="M134,35.8c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v6.5c0,0,0,0.1,0.1,0.1


		h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7C134.1,35.8,134,35.8,134,35.8z"/>


          <path d="M146.3,35.7l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C146.3,35.8,146.3,35.8,146.3,35.7z M143.6,33.1h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L143.6,33.1


		C143.6,33,143.6,33.1,143.6,33.1z"/>


          <path d="M153.6,35.7l-1.4-3.2c0,0,0,0-0.1,0h-0.8c0,0-0.1,0-0.1,0.1v3.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h3.6c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.9,0.3,1.4


		c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.7-1.1,0.9c0,0-0.1,0,0,0.1l1.6,3.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C153.7,35.8,153.6,35.8,153.6,35.7z M151.3,29.2v1.7c0,0,0,0.1,0.1,0.1h1.3c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.7


		c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3L151.3,29.2C151.3,29.1,151.3,29.2,151.3,29.2z"/>


          <path d="M159.3,26.6c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8s0.4-0.3,0.8-0.3c0.3,0,0.6,0.1,0.7,0.3


		c0.2,0.2,0.3,0.4,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.3-0.7,0.3C159.7,26.9,159.5,26.8,159.3,26.6z M159.1,35.8


		c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7


		C159.1,35.8,159.1,35.8,159.1,35.8z"/>


          <path d="M162.3,35.8c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0s0,0.1,0,0.1v6.5c0,0,0,0.1,0.1,0.1h3.8


		c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7C162.3,35.8,162.3,35.8,162.3,35.8z"/>


          <path d="M175,29.1c0,0-0.1,0-0.1,0h-3.8c0,0-0.1,0-0.1,0.1v1.5c0,0,0,0.1,0.1,0.1h2.4c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-2.4c0,0-0.1,0-0.1,0.1v1.6c0,0,0,0.1,0.1,0.1h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-8.1c0,0,0-0.1,0-0.1s0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0


		s0,0.1,0,0.1V29C175.1,29,175,29.1,175,29.1z"/>


          <path d="M66.6,48.1l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0s0-0.1,0-0.1


		l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1H66c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C66.7,48.2,66.6,48.2,66.6,48.1z M63.9,45.5h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0s0,0,0,0L63.9,45.5


		C63.9,45.4,63.9,45.5,63.9,45.5z"/>


          <path d="M69.6,48.2c0,0,0-0.1,0-0.1V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h3.1c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.5,1.1,0.9


		c0.3,0.4,0.4,0.9,0.4,1.4v3.1c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.7-1.1,0.9c-0.5,0.2-1,0.3-1.7,0.3h-3.1


		C69.7,48.2,69.7,48.2,69.6,48.2z M71.6,46.5h1.2c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.9v-2.5c0-0.4-0.1-0.7-0.3-0.9


		c-0.2-0.2-0.5-0.3-0.8-0.3h-1.2c0,0-0.1,0-0.1,0.1L71.6,46.5C71.6,46.5,71.6,46.5,71.6,46.5z"/>


          <path d="M77.3,39c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.8-0.3c0.3,0,0.6,0.1,0.7,0.3


		c0.2,0.2,0.3,0.4,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.3-0.7,0.3C77.7,39.3,77.5,39.2,77.3,39z M77.1,48.2


		c0,0,0-0.1,0-0.1V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v8.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0


		h-1.7C77.1,48.2,77.1,48.2,77.1,48.2z"/>


          <path d="M80.2,48.2c0,0,0-0.1,0-0.1V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0H82c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v6.5c0,0,0,0.1,0.1,0.1


		h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7C80.3,48.2,80.3,48.2,80.2,48.2z"/>


          <path d="M90.9,48c-0.5-0.3-0.9-0.6-1.1-1.1c-0.3-0.5-0.4-1-0.4-1.6v-2.4c0-0.6,0.1-1.1,0.4-1.6c0.3-0.5,0.7-0.8,1.1-1.1


		c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6v2.4c0,0.6-0.1,1.2-0.4,1.6


		c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C92,48.4,91.4,48.2,90.9,48z M93.5,46.3c0.2-0.2,0.4-0.6,0.4-1v-2.5


		c0-0.4-0.1-0.7-0.4-1s-0.5-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.4,0.6-0.4,1v2.5c0,0.4,0.1,0.7,0.4,1


		c0.2,0.2,0.5,0.4,0.9,0.4C93,46.7,93.3,46.5,93.5,46.3z"/>


          <path d="M97,48.2c0,0,0-0.1,0-0.1V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v6.5c0,0,0,0.1,0.1,0.1


		h3.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-5.7C97,48.2,97,48.2,97,48.2z"/>


          <path d="M109.2,48.1l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1l2.6-8.1c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C109.3,48.2,109.2,48.2,109.2,48.1z M106.6,45.5h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L106.6,45.5


		C106.5,45.4,106.5,45.5,106.6,45.5z"/>


          <path d="M116.6,48.1l-1.4-3.2c0,0,0,0-0.1,0h-0.8c0,0-0.1,0-0.1,0.1v3.1c0,0,0,0.1,0,0.1s-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h3.6c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.9,0.3,1.4


		c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.7-1.1,0.9c0,0-0.1,0,0,0.1l1.6,3.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C116.6,48.2,116.6,48.2,116.6,48.1z M114.2,41.6v1.7c0,0,0,0.1,0.1,0.1h1.3c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.7


		c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3L114.2,41.6C114.2,41.5,114.2,41.6,114.2,41.6z"/>


          <path d="M125,48.1l-0.3-1.1c0,0,0,0-0.1,0h-2.7c0,0,0,0-0.1,0l-0.3,1.1c0,0.1-0.1,0.1-0.2,0.1h-1.8c0,0-0.1,0-0.1,0


		c0,0,0-0.1,0-0.1L122,40c0-0.1,0.1-0.1,0.2-0.1h2.3c0.1,0,0.1,0,0.2,0.1l2.6,8.1c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C125.1,48.2,125,48.2,125,48.1z M122.3,45.5h1.8c0,0,0.1,0,0-0.1l-0.9-3.1c0,0,0,0,0,0c0,0,0,0,0,0L122.3,45.5


		C122.3,45.4,122.3,45.5,122.3,45.5z"/>


          <path d="M128,48.2c0,0,0-0.1,0-0.1V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v3.1c0,0,0,0,0,0


		c0,0,0,0,0,0l2.4-3.2c0-0.1,0.1-0.1,0.2-0.1h1.9c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1l-2.6,3.5c0,0,0,0.1,0,0.1l2.7,4.5


		c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.9c-0.1,0-0.1,0-0.2-0.1l-1.9-3.2c0,0-0.1,0-0.1,0l-0.6,0.9c0,0,0,0.1,0,0.1v2.2


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7C128.1,48.2,128.1,48.2,128,48.2z"/>


          <path d="M139.4,48c-0.5-0.3-0.9-0.6-1.1-1.1c-0.3-0.5-0.4-1-0.4-1.6v-2.4c0-0.6,0.1-1.1,0.4-1.6c0.3-0.5,0.7-0.8,1.1-1.1


		c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6v2.4c0,0.6-0.1,1.2-0.4,1.6


		c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C140.5,48.4,139.9,48.2,139.4,48z M142,46.3c0.2-0.2,0.4-0.6,0.4-1v-2.5


		c0-0.4-0.1-0.7-0.4-1c-0.2-0.3-0.5-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.4,0.6-0.4,1v2.5c0,0.4,0.1,0.7,0.4,1


		c0.2,0.2,0.5,0.4,0.9,0.4C141.5,46.7,141.8,46.5,142,46.3z"/>


          <path d="M145.5,48.2c0,0,0-0.1,0-0.1V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v3.1c0,0,0,0,0,0


		s0,0,0,0l2.4-3.2c0-0.1,0.1-0.1,0.2-0.1h1.9c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1l-2.6,3.5c0,0,0,0.1,0,0.1l2.7,4.5


		c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.9c-0.1,0-0.1,0-0.2-0.1l-1.9-3.2c0,0-0.1,0-0.1,0l-0.6,0.9c0,0,0,0.1,0,0.1v2.2


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7C145.5,48.2,145.5,48.2,145.5,48.2z"/>


          <path d="M154.5,48c-0.5-0.2-0.9-0.6-1.1-1c-0.3-0.4-0.4-1-0.4-1.5V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1v5.4c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,0.9,0.3c0.4,0,0.6-0.1,0.9-0.3c0.2-0.2,0.3-0.5,0.3-0.9V40


		c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v5.4c0,0.6-0.1,1.1-0.4,1.5c-0.3,0.4-0.6,0.8-1.1,1


		s-1,0.4-1.7,0.4S155,48.2,154.5,48z"/>


          <path d="M162.7,48.2c0,0,0-0.1,0-0.1v-2.8c0,0,0-0.1,0-0.1l-2.5-5.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.1h1.8c0.1,0,0.1,0,0.2,0.1


		l1.3,3c0,0,0,0,0.1,0l1.3-3c0-0.1,0.1-0.1,0.2-0.1h1.9c0.1,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1l-2.5,5.1c0,0,0,0,0,0.1v2.8


		c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.7C162.8,48.2,162.8,48.2,162.7,48.2z"/>


          <path d="M169.1,48c-0.5-0.3-0.9-0.6-1.1-1.1c-0.3-0.5-0.4-1-0.4-1.6v-2.4c0-0.6,0.1-1.1,0.4-1.6c0.3-0.5,0.7-0.8,1.1-1.1


		c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6v2.4c0,0.6-0.1,1.2-0.4,1.6


		c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C170.1,48.4,169.5,48.2,169.1,48z M171.7,46.3c0.2-0.2,0.4-0.6,0.4-1v-2.5


		c0-0.4-0.1-0.7-0.4-1c-0.2-0.3-0.5-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.4,0.6-0.4,1v2.5c0,0.4,0.1,0.7,0.4,1


		c0.2,0.2,0.5,0.4,0.9,0.4C171.2,46.7,171.5,46.5,171.7,46.3z"/>


          <path d="M179.4,48.1l-1.4-3.2c0,0,0,0-0.1,0h-0.8c0,0-0.1,0-0.1,0.1v3.1c0,0,0,0.1,0,0.1s-0.1,0-0.1,0h-1.7c0,0-0.1,0-0.1,0


		s0-0.1,0-0.1V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h3.6c0.5,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.9,0.3,1.4


		c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.7-1.1,0.9c0,0-0.1,0,0,0.1l1.6,3.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1h-1.8


		C179.5,48.2,179.5,48.2,179.4,48.1z M177.1,41.6v1.7c0,0,0,0.1,0.1,0.1h1.3c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.7


		c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3L177.1,41.6C177.1,41.5,177.1,41.6,177.1,41.6z"/>


          <path d="M183.9,48c-0.5-0.2-0.9-0.6-1.1-1c-0.3-0.4-0.4-1-0.4-1.5V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0


		c0,0,0,0.1,0,0.1v5.4c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.5,0.3,0.9,0.3c0.4,0,0.6-0.1,0.9-0.3c0.2-0.2,0.3-0.5,0.3-0.9V40


		c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h1.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v5.4c0,0.6-0.1,1.1-0.4,1.5c-0.3,0.4-0.6,0.8-1.1,1


		s-1,0.4-1.7,0.4S184.4,48.2,183.9,48z"/>


          <path d="M189.7,48.2c0,0,0-0.1,0-0.1v-1.6c0-0.1,0-0.1,0.1-0.2l3.7-4.7c0,0,0,0,0,0s0,0,0,0h-3.6c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1


		V40c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0h5.7c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.6c0,0.1,0,0.1-0.1,0.2l-3.7,4.7c0,0,0,0,0,0


		c0,0,0,0,0,0h3.6c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v1.4c0,0,0,0.1,0,0.1s-0.1,0-0.1,0h-5.7C189.8,48.2,189.7,48.2,189.7,48.2z"/>


</g>


        <g>


	<g>


		<path d="M42.8,15.7c-1.1,0-1.9-0.9-1.9-1.9v-5c-8.5-4.1-26.6-3.8-31.4,2c-5.4,6.7-6.6,28.9,0,34.4c6.6,5.5,27.7,5.4,34.4,0


			c5.4-4.4,6-20.4,2.8-29.4H42.8z"/>


    <path d="M40.9,0.6h-2.3c-1.1,0-2,0.9-2,2v2.3c0,0.5,0.4,0.9,0.9,0.9h2.3c1.1,0,2-0.9,2-2V1.5C41.8,1,41.4,0.6,40.9,0.6z"/>


    <path d="M57.3,0H55c-1.1,0-2,0.9-2,2v2.3c0,0.5,0.4,0.9,0.9,0.9h2.3c1.1,0,2-0.9,2-2V0.9C58.2,0.4,57.8,0,57.3,0z"/>


    <path d="M55.3,13.5h-3.1c-1.4,0-2.6,1.2-2.6,2.6v3.1c0,0.6,0.5,1.2,1.2,1.2h3.1c1.4,0,2.6-1.2,2.6-2.6v-3.1


			C56.4,14.1,55.9,13.5,55.3,13.5z"/>


    <path d="M49.8,4.7h-4.2c-2,0-3.6,1.6-3.6,3.6v4.2c0,0.9,0.7,1.6,1.6,1.6h4.2c2,0,3.6-1.6,3.6-3.6V6.3C51.4,5.4,50.7,4.7,49.8,4.7z


			"/>


	</g>


          <path class="st0" d="M32.2,9.6l-4.4,15.9l7.1,1.1c1.1,0.2,1.6,1.5,0.8,2.3L20.5,45.6l4.8-15.2l-7.8-1.3c-1.1-0.2-1.5-1.5-0.8-2.3


		L32.2,9.6z"/>


</g>


</svg>








  </div>

</template>

<script>
export default {}
</script>

<style>	.st0{fill:#FFFFFF;}</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/LazerReklam.vue